import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchFeatures(searchString) {
  return retryRequest(() =>
    apiRequest(`/features${searchString ? `?${searchString}` : ``}`),
  );

  /*const normalizedData = response.results.map(item => ({
        ...item,
        filterableSV: item.filterableSV === 'TRUE',
        filterableNO: item.filterableNO === 'TRUE',
        filterableFI: item.filterableFI === 'TRUE'
    }));

    return normalizedData;*/
}

export async function editFeature(feature) {
  return retryRequest(() =>
    apiRequest(`/feature/edit/${feature.featureId}`, {
      method: "PUT",
      body: JSON.stringify(feature),
    }),
  );
}

export async function saveFeature(feature) {
  return retryRequest(() =>
    apiRequest("/feature/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(feature),
    }),
  );
}

export async function deleteFeature(feature) {
  return retryRequest(() =>
    apiRequest(`/feature/delete/${feature.featureId}`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    }),
  );
}
